<template>
  <div>
    <ul class="links">
      <router-link
        tag="li"
        v-for="item in links"
        :key="item.url"
        :to="item.url">
        {{item.info}}
      </router-link>
    </ul>
    {{'系统：' + Os}}，
    {{'浏览器：' + Browser}}
    <p @click="test">window.location.href = '/experience/apply'</p>
  </div>
</template>

<script>
import Os from '@/common/utils/Os.js'
import Browser from '@/common/utils/Browser.js'
import UpdateLogData from '@/data/api/common/Log/UpdateLogData.js'
export default {
  name: 'indexPage',
  data () {
    return {
      links: [
        {url: '/download', info: '/download 下载页'},
        {url: '/questions', info: '/questions 问券页'},
        {url: '/questionsAnswer', info: '/questionsAnswer 问券答题页'},
        {url: '/questionsVoucher', info: '/questionsVoucher 问券领券页'},
        {url: '/questionsThank', info: '/questionsThank 感谢参与'},
        {url: '/experience', info: '/experience 体验官招募'},
        {url: '/experienceApply', info: '/experienceApply 体验官报名'},
        {url: '/experienceExplist', info: '/experienceExplist 新用户体验官招募报名成功页'},
        {url: '/experienceOldExplist', info: '/experienceOldExplist 老用户体验官招募报名成功页'},
        {url: '/experienceExpdetail', info: '/experienceExpdetail 体验官招募报名成功页2'}
        // {url: '/login', info: 'login 登录'}
      ],
      Os: '',
      Browser: '',
      salePriceData: {
        tipsTitle: '售价(万元)',
        rulesReg: /^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/,
        tipsInfo: '须是非零正数!',
        keyValue: 'salePrice'
      }
    }
  },
  mounted () {
    this.Os = Os.getOsType()
    this.Browser = Browser.getBrowserType()
    // 打点上报公共方法
    UpdateLogData({path: this.$route.path, action: 'finishLoad', query: this.$route.query, hasRedPacket: false})
  },
  methods: {
    test () {
      window.location.href = '/#/experience/apply'
      document.title = '首席体验官招募令'
    }
  }
}
</script>

<style scoped lang="stylus">
.links{
  width: 100%;
  line-height: 40px;
  text-indent: 20px;
  text-decoration: underline;
  font-size:14px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/index.vue